import React from "react";

const IconNavArrowDown = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			// width="18px"
			// height="18px"
			stroke-width="1.7px"
			stroke="currentColor"
		>
			<path
				d="M6 9l6 6 6-6"
				stroke-linecap="round"
				stroke-linejoin="round"
			></path>
		</svg>
	);
};

export default IconNavArrowDown;
